export const isProjectGroup = (group: any) => {
  if (group.groups[0]?.groups[0]?.data?.length) {
    return true;
  }
  return false;
};

export const isPackageGroup = (group: any) => {
  if (group.groups[0]?.data?.length) {
    return true;
  }
  return false;
};

export const isCVEGroup = (group: any) => {
  if (group.data?.length) {
    return true;
  }
  return false;
};
